<template>
    <transition name="fade" v-on:before-enter="beforeEnter">
        <div v-if="popupVisible" id="app-popup" @click="handleClose">
            <vuescroll ref="vs">
                <transition name="slide">
                    <div class="container" v-if="show">
                        <component :is="popupComponent" :clear="true" @close="handleClose"
                                   @up-click="handleScrollTop"></component>
                    </div>
                </transition>
            </vuescroll>
        </div>
    </transition>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import vuescroll from 'vuescroll'
    import ComponentSwitcher from "./common/ComponentSwitcher";

    export default {
        name: 'popup-component',
        components: {ComponentSwitcher, vuescroll},
        data() {

            return {
                show: false
            }
        },
        computed: {
            ...mapState({
                popupVisible: state => state.popupVisible,
                popupComponent: state => state.popupComponent,
            }),
        },
        methods: {
            beforeEnter() {
                this.show = true;
            },
            ...mapActions([
                'switchPopup'
            ]),
            handleClose() {
                this.show = false;
                setTimeout(() => {
                    this.switchPopup(false);
                }, 100);
            },
            handleScrollTop() {
                this.$refs['vs'].scrollTo(
                    {
                        y: '0%'
                    },
                    500
                );
            }
        },
    }
</script>

<style scoped>
    .slide-leave-active, .slide-enter-active {
        transition: opacity .2s, all .2s ease .2s;
    }
    .slide-enter {
        -webkit-transform: translate3d(0, -50px, 0);
        transform: translate3d(0, -50px, 0);
        opacity: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter-to, .fade-leave {
        opacity: 1;
    }

    .fade-leave-to, .fade-enter {
        opacity: 0;
    }
</style>
